import { confirmCJPassword } from "./CJPasswordConfirmationSession";

export const PASSWORD_CONFIRMATION_ACTIONS = Object.freeze({
  CJ_SYNC_FINALIZE: "CJ_SYNC_FINALIZE",
  CJ_SYNC_UPDATE: "CJ_SYNC_UPDATE",
  CJ_SYNC_DELETE: "CJ_SYNC_DELETE",
  CJ_FILTER_UPDATE: "CJ_FILTER_UPDATE",
  CJ_FILTER_DELETE: "CJ_FILTER_DELETE",
  CJ_SYNC_ALL: "CJ_SYNC_ALL",
});

export const requestElakayPasswordConfirmation = ({ password }) => confirmCJPassword(password);
